import React, { useCallback, useContext, useEffect, useState } from "react";

import Accordion from "../../components/Accordions/Accordion";
import CalendarTariff from "mg-calendar-tariff";
import { DesignProgramContext } from "../CustomHooks/ContextApi";
import LoadShedding from "../DesignPrograms/LoadShedding"
import embLabels from "../../config/emb-labels-en.json";
import isTouchDevice from "../SE-Component/Tooltip";
import LABEL_VALIDATIONS from "../../config/LABEL_VALIDATIONS.json";
import LABELS from "../../config/LABELS.json";
import moment from "moment";
import _ from "lodash";
import Tooltip from "../../utils/Tooltip";
import { useSelector } from "react-redux";
import { getProject, getProjectTypeValue } from "../../utils/project";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";
import DevicePriority from "../../components/DevicePriority";
import UtilityBillingContract from "../../components/BillingContract/UtilityBillingContract";
import DemandLimitCalculation from "../../components/DemandLimitCalculation/DemandLimitCalculation";

const OnGridOptimization = () => {
  const {
    clientType,
    gridSettings,
    isRealTimeExportConfg,
    isMotorizedOrContactor,
    configuredStatus,
    demandChargeOutput,
    siteType,
    maxExportPower,
    peakImportHysteresis,
     maxLimitEnergyExportPower,
    maxLimitEnergyImportPower,
    derMaxPowerMap,
    limitImportExport,
    importStartHysteresis,
    importStopHysteresis,
    batteryDetails,
    pvCurtailmentExport,
    lossOfComm,
    lossOfCommEMA,
    utilityLSIEnable,
    templateSelected,
    architectureType,
    demandChargeDataCallback,
    tariffDynamicConfiguration,
    handleDynamicTariffConfiguration,
    exportManagementChange,
    configuredStatusModified,
    handleChange,
    handleCheckBoxChange,
    handlepPVOpeningPopup,
    enableTemplatePopUp,
    isBessOperatingMode,
    exportManagementBessMode,
    refresh,
    outerResetTrigger,
    validateProgram,
    validResultFunc,
    siteCreated,
    projectStatusData,
    UserScope,
    sellTariff,
    deltaSellTariff,
    handleLimitExportImportOptimization,
    limitExport,
    limitImport,
    currency,
    defaultDynamicTariff,
    demandChargeUseCaseSelection,
    eVceData,
    isTMHSelected,
    evMaxAllowedPower,
    handleEVCE,
    handleBillingCycle,
    billingPeriod,
    handleDcthreshold,
    dcthreshold,
    handleDcThresholdCustomMonth,
    dcthresholdCustomMonthErrors,
    updateUtilityDates,
    generateDefaultData,
    exportManagementhandler,
    importManagementhandler,

  } = useContext(DesignProgramContext);
  const projectTypeValue = useProjectTypeValue();
  const isGridSiteWithImportLimitationTrue = limitImport && (siteType === "GRID_CONNECTED" && (["MGaaS ANSI", "MGaaS IEC", "MGaaS ETO", "NMGaaS ETO"].includes(projectTypeValue)));
  const showLoadManagement = projectTypeValue === "NMGaaS ETO"
    ? gridSettings?.loadManagement === true
    : (gridSettings?.exportOptimization === true && siteType === embLabels.GRID_CONNECTED) ||
    siteType === embLabels.ISLANDABLE ||
    siteType === embLabels.OFF_GRID;
  const loadManagementDisplayStatus =
    [embLabels.ISLANDABLE, embLabels.OFF_GRID].includes(siteType)
      ? "1"
      : siteType === embLabels.GRID_CONNECTED && isGridSiteWithImportLimitationTrue
        ? "1"
        : "0";
  const loadManagementDisabledClass =
    (siteCreated && projectTypeValue !== "NMGaaS ETO")||
      projectStatusData?.projectStatus === "COMPLETED" ||
      projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
      ? "se-block-disabled not-allowed"
      : !UserScope.access.saveProgram
        ? "se-block-disabled"
        : "";
  const projectKind = getProject();
  const tooltipData = useSelector((state) => state?.tooltipData?.tooltipData);
  const epexAreaMap =
    defaultDynamicTariff?.tariffTypeList?.["24-Hour Day Ahead Tariff"]?.[1]?.[
      "EPEX"
    ] || {};
  const epexAreaList = Object.keys(epexAreaMap);
  const selectedEpexArea =
    tariffDynamicConfiguration?.dynamicHourTariff?.platformDayAhead ||
    epexAreaList?.[0] ||
    "";
  const epexResolutionList = epexAreaMap?.[selectedEpexArea] || [];
  const selectedEpexResolution =
    tariffDynamicConfiguration?.dynamicHourTariff?.resolution ||
    epexResolutionList?.[0] ||
    "";
  const [alertPopup, setAlertPopup] = useState({
    message: "",
    alertPopUpStatus: false,
    title: "Alert",
  });
  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      let getFDCelementradio = document.getElementById("fdcType");
      const getFDCelement = document.getElementById("use-case-fdc");
      if (
        getFDCelement &&
        projectTypeValue?.includes("ANSI") &&
        getFDCelementradio
      ) {
        if (
          getFDCelement &&
          getFDCelement?.style &&
          getFDCelementradio?.parentElement
        ) {
          getFDCelement.style.cursor = "not-allowed";
          getFDCelementradio.parentElement.style.pointerEvents = "none";
          getFDCelementradio.style.cursor = "not-allowed";
        }
      }
      const allowDisable =
        projectTypeValue?.includes("ANSI") || projectTypeValue?.includes("IEC");
      if (allowDisable) {
        for (let mutation of mutationsList) {
          if (mutation.type === "childList" || mutation.type === "attributes") {
            const selectElement = document.querySelector(
              'select.custom-select[name="penaltyCalculation"]'
            );
            if (selectElement) {
              const usOption = selectElement.querySelector(
                `option[value=${projectTypeValue?.includes("ANSI") ? "PORTUGUESE" : "US"
                }]`
              );

              if (usOption) {
                usOption.style.display = "none";
              }
              break;
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);
  const closeAlertPopup = useCallback(() => {
    setAlertPopup({
      message: "",
      alertPopUpStatus: false,
      title: "",
    });
  }, [alertPopup]);
  const exportManagementChangeHandler = () => {
    exportManagementChange();
    configuredStatusModified("emConfiguredStatus");
  };

  const maxExportImportPowerChangeHandler = (e) => {
    handleChange(e);
    configuredStatusModified("emConfiguredStatus");
  };

  const exportFunctionChangeHandler = (e) => {
    const { name, id } = e.target;
    if (
      isMotorizedOrContactor?.isPvCBsMotorizedOrContactor === false &&
      id === "isPvCBsMotorizedOrContactor"
    ) {
      setAlertPopup({
        message:
          "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches.",
        alertPopUpStatus: true,
        title: "Alert",
      });
    } else if (
      isMotorizedOrContactor?.isBessCBsMotorizedOrContactor === false &&
      id === "isBessCBsMotorizedOrContactor"
    ) {
      setAlertPopup({
        message:
          "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches.",
        alertPopUpStatus: true,
        title: "Alert",
      });
    }
    else {
      handleCheckBoxChange(e);
      configuredStatusModified("exportManagementStatus");
    }
    if(projectKind?.projectTypeValue === "NMGaaS ETO"){
      configuredStatusModified("exportManagementStatus1");
    }
  };

  const utilityLSIChangeHandler = (e) => {
    const { name, id } = e.target;
    if (
      isMotorizedOrContactor?.isPvCBsMotorizedOrContactor === false &&
      id === "isBessCBsMotorizedOrContactor"
    ) {
      setAlertPopup({
        message:
          "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches",
        alertPopUpStatus: true,
        title: "Alert",
      });
    } else {
      configuredStatusModified("exportManagementStatus");
      handlepPVOpeningPopup(e);
    }
  };

  const hysteresisChangeHandler = (e) => {
    handleChange(e);
    configuredStatusModified("realTimeControlEMA");
  };

  const getTooltipDataImportPower = () => {
    const tooltip = tooltipData?.limitMaxEnergyImportTooltipData?.data?.split('\\');
    return tooltip;
  }
  const maxImportPowerDisplayValue =
    limitImportExport?.maxLimitEnergyImportPower ?? maxLimitEnergyImportPower;
 const getLimitMaxEnergyExportTooltipData  = () => {
    const tooltip = tooltipData?.limitMaxEnergyExportTooltipData?.data?.split('\\');
    return tooltip;
  }
  const isExportFunctionEnabled =
    gridSettings?.noExport === true || gridSettings?.exportOptimization === true;

  const renderPvCurtailmentRow = (id, onChangeHandler) => (
    <div className="row">
      <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
        <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input asCompatible"
            name="pvCurtailmentExport"
            id={id}
            value={pvCurtailmentExport}
            checked={pvCurtailmentExport}
            disabled={!isExportFunctionEnabled}
            onChange={onChangeHandler}
          />
          <label
            className="custom-control-label line-height-25"
            htmlFor={id}
          >
            PV curtailment
          </label>
          <Tooltip
            position="right"
            iconColor="secondary"
            information={tooltipData?.pVCurtailment?.data}
          />
        </div>
      </div>
    </div>
  );

  const renderUtilityLSIRow = (id, information, disabled) => (
    <div className="row">
      <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
        <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input asCompatible"
            name="utilityLSIEnable"
            id={id}
            checked={utilityLSIEnable}
            disabled={disabled}
            onChange={utilityLSIChangeHandler}
          />
          <label
            className="custom-control-label line-height-25"
            htmlFor={id}
          >
            PV breakers opening
          </label>
          <Tooltip
            position="right"
            iconColor="secondary"
            information={information}
          />
        </div>
      </div>
    </div>
  );

  return (
    <>
      {(gridSettings?.noExport === true ||
        gridSettings?.exportOptimization === true ||
        gridSettings?.tariffManagement === true ||
        gridSettings?.selfConsumption === true ||
        gridSettings?.demandCharge === true ||
        gridSettings?.manualDemandResponse === true ||
        gridSettings?.greenConsumption === true ||
        gridSettings?.netMetering === true ||
        gridSettings?.bessEnergyExchanges === true ||
        gridSettings?.bessEnergyExchanges === false) && (
          <div
            className={`row se-white-background pb-2 ${!UserScope.access.saveProgram ? "se-block-disabled" : ""
              }`}
          >
            {/* Energy Optimization */}
            {<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-2 ">
              <span className="se-font-14px-bold se-life-green ">
                Power Optimization
              </span>

              <div className="row ">
                {gridSettings?.noExport === false &&
                  gridSettings?.exportOptimization === false &&
                  gridSettings?.tariffManagement === false &&
                  gridSettings?.selfConsumption === false &&
                  gridSettings?.demandCharge === false &&
                  gridSettings?.manualDemandResponse === false &&
                  gridSettings?.noImport === false &&
                  gridSettings?.greenConsumption === false &&
                  gridSettings?.netMetering === false &&
                  !(
                    gridSettings?.bessEnergyExchanges === true ||
                    gridSettings?.bessEnergyExchanges === false
                  ) ? (
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="row">
                      <label className="col-md-7 col-form-label pl-5">
                        No on-grid optimization usecase
                      </label>
                    </div>
                  </div>
                ) : (
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <Accordion allowMultipleOpen>
                      <div
                        className="col-md-12"
                        label="Demand Charge and Time of Use Tariff "
                        status={
                          configuredStatus.dcConfiguredStatus === 1 ||
                            configuredStatus.dynamicConfiguredStatus === 1 ||
                            configuredStatus.sellTariffConfiguredStatus === 1
                            ? 1
                            : configuredStatus.dcConfiguredStatus === 2 ||
                              configuredStatus.dynamicConfiguredStatus === 2 ||
                              configuredStatus.sellTariffConfiguredStatus === 2
                              ? 2
                              : 0
                        }
                        displayStatus={
                          projectTypeValue === "NMGaaS ETO" ? "0" :
                            gridSettings?.demandCharge === true ||
                              gridSettings?.tariffManagement === true
                              ? "1"
                              : "0"
                        }
                        icon="notification_error_full_stroke"
                        enableTemplatePopUp={enableTemplatePopUp}
                      >
                        <div className="row p-3">
                          <Accordion allowMultipleOpen>
                            <div
                              className={`col-md-12 `}
                              label=" Static Tariff Configuration"
                              status={configuredStatus.dcConfiguredStatus}
                              displayStatus="1"
                              icon="notification_error_full_stroke"
                              enableTemplatePopUp={enableTemplatePopUp}
                            >
                              <div
                                className={`${(siteCreated &&  projectTypeValue !== "NMGaaS ETO")||
                                    projectStatusData?.projectStatus ===
                                    "COMPLETED" ||
                                    projectStatusData?.projectStatus ===
                                    "COMPLETED_AND_SEND"
                                    ? "se-block-disabled not-allowed"
                                    : !UserScope.access.saveProgram
                                      ? "se-block-disabled"
                                      : ""
                                  }`}
                              >
                                <CalendarTariff
                                  lastSubmit={refresh}
                                  validResult={validResultFunc}
                                  demandChargeData={demandChargeOutput}
                                  currency={currency?.symbol}
                                  draftCallback={demandChargeDataCallback}
                                  demandChargeUseCase={gridSettings?.demandCharge}
                                  timeOfUseCase={gridSettings?.tariffManagement}
                                  customLabels={LABELS}
                                  weekdayLabels={_.map(
                                    [1, 2, 3, 4, 5, 6, 0],
                                    (day) => moment.weekdays()[day]
                                  )}
                                  templateSel={templateSelected}
                                  VALIDATION_LABELS={LABEL_VALIDATIONS}
                                ></CalendarTariff>
                              </div>
                            </div>
                            {["DaaS ANSI", "MGaaS ANSI"].includes(projectKind?.projectTypeValue) && (demandChargeUseCaseSelection === "DCMP") &&
                              <div
                                className={`col-md-12 `}
                                label="Utility Billing Contract"
                                status={1}
                                displayStatus="1"
                                icon="notification_error_full_stroke"
                              >
                                <div

                                >
                                  {billingPeriod && <UtilityBillingContract
                                    handleBillingCycle={handleBillingCycle}
                                    billingPeriod={billingPeriod}
                                    dcthresholdCustomMonthErrors={dcthresholdCustomMonthErrors}
                                    updateUtilityDates={updateUtilityDates}
                                    dcthreshold={dcthreshold}
                                    projectStatusData={projectStatusData}
                                    siteCreated={siteCreated}
                                    projectTypeValue={projectTypeValue}
                                  />}
                                </div>
                              </div>
                            }
                            {["DaaS ANSI", "MGaaS ANSI"].includes(projectKind?.projectTypeValue) && (demandChargeUseCaseSelection === "DCMP") &&
                              <div
                                className={`col-md-12 `}
                                label="DC threshold preset configuration"
                                status={configuredStatus.dcThresholdStatus}
                                displayStatus="1"
                                icon="notification_error_full_stroke"
                              >
                                <div
                                  className={` col-md-12 ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                                      projectStatusData?.projectStatus ===
                                      "COMPLETED" ||
                                      projectStatusData?.projectStatus ===
                                      "COMPLETED_AND_SEND"
                                      ? "se-block-disabled not-allowed"
                                      : !UserScope.access.saveProgram
                                        ? "se-block-disabled"
                                        : ""
                                    }`}
                                >
                                  <DemandLimitCalculation
                                    handleDcthreshold={handleDcthreshold}
                                    dcthreshold={dcthreshold}
                                    handleDcThresholdCustomMonth={handleDcThresholdCustomMonth}
                                    dcthresholdCustomMonthErrors={dcthresholdCustomMonthErrors}
                                    generateDefaultData={generateDefaultData}
                                  />
                                </div>
                              </div>
                            }
                            {!["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(
                              projectKind?.projectTypeValue
                            ) && (
                                <div
                                  className={`col-md-12 mt-2 `}
                                  label=" Dynamic Tariff Configuration"
                                  status={configuredStatus.dynamicConfiguredStatus}
                                  displayStatus="1"
                                  icon="notification_error_full_stroke"
                                  enableTemplatePopUp={enableTemplatePopUp}
                                >
                                  <div
                                    className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                                        projectStatusData?.projectStatus ===
                                        "COMPLETED" ||
                                        projectStatusData?.projectStatus ===
                                        "COMPLETED_AND_SEND"
                                        ? "se-block-disabled not-allowed"
                                        : !UserScope.access.saveProgram
                                          ? "se-block-disabled"
                                          : ""
                                      }`}
                                  >
                                    <div className="row">
                                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ">
                                        <div className="row pl-3">
                                          <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                            <div className="custom-control custom-radio">
                                              <input
                                                type="radio"
                                                id="none"
                                                name="tariffType"
                                                className="custom-control-input islandableRadio  asCompatible"
                                                checked={
                                                  tariffDynamicConfiguration ===
                                                  null
                                                }
                                                onClick={
                                                  handleDynamicTariffConfiguration
                                                }
                                                value="null"
                                              />
                                              <label
                                                className="custom-control-label line-height-25px"
                                                htmlFor="none"
                                              >
                                                None
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                            <div className="custom-control custom-radio">
                                              <input
                                                type="radio"
                                                id="dayTariff24hHours"
                                                name="tariffType"
                                                className="custom-control-input islandableRadio  asCompatible"
                                                checked={
                                                  tariffDynamicConfiguration?.tariffType ===
                                                  "dynamic"
                                                }
                                                onClick={
                                                  handleDynamicTariffConfiguration
                                                }
                                                value="dynamic"
                                              />
                                              <label
                                                className="custom-control-label line-height-25px"
                                                htmlFor="dayTariff24hHours"
                                              >
                                                24 hour day ahead Tariff
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                            <div className="custom-control custom-radio">
                                              <input
                                                type="radio"
                                                id="spotPrice"
                                                name="tariffType"
                                                className="custom-control-input islandableRadio  asCompatible"
                                                checked={
                                                  tariffDynamicConfiguration?.tariffType ===
                                                  "spotPrice"
                                                }
                                                onClick={
                                                  handleDynamicTariffConfiguration
                                                }
                                                value="spotPrice"
                                              />
                                              <label
                                                className="custom-control-label line-height-25px"
                                                htmlFor="spotPrice"
                                              >
                                                Spot Price
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {tariffDynamicConfiguration?.tariffType ===
                                        "dynamic" && (
                                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 mt-2">
                                            <div className="row pl-3">
                                              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <span className="bold ">
                                                  Select Platform :
                                                </span>
                                              </div>
                                              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ">
                                                <div className="row pl-4">
                                                  <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                                    <div className="custom-control custom-radio">
                                                      <input
                                                        type="radio"
                                                        id="omieBasedTariff"
                                                        name="platform"
                                                        className="custom-control-input islandableRadio  asCompatible"
                                                        checked={
                                                          tariffDynamicConfiguration
                                                            ?.dynamicHourTariff
                                                            ?.platformType === "omie"
                                                        }
                                                        onClick={
                                                          handleDynamicTariffConfiguration
                                                        }
                                                        value="omie"
                                                      />
                                                      <label
                                                        className="custom-control-label line-height-25px"
                                                        htmlFor="omieBasedTariff"
                                                      >
                                                        OMIE based tariff
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                                    <div className="custom-control custom-radio">
                                                      <input
                                                        type="radio"
                                                        id="epexBasedTariff"
                                                        name="platform"
                                                        className="custom-control-input islandableRadio  asCompatible"
                                                        checked={
                                                          tariffDynamicConfiguration
                                                            ?.dynamicHourTariff
                                                            ?.platformType === "epex"
                                                        }
                                                        onClick={
                                                          handleDynamicTariffConfiguration
                                                        }
                                                        value="epex"
                                                      />
                                                      <label
                                                        className="custom-control-label line-height-25px"
                                                        htmlFor="epexBasedTariff"
                                                      >
                                                        EPEX based tariff
                                                      </label>
                                                    </div>
                                                  </div>
                                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div className="row">
                                                      {(tariffDynamicConfiguration
                                                        ?.dynamicHourTariff
                                                        ?.platformType === "omie" ||
                                                        tariffDynamicConfiguration
                                                          ?.dynamicHourTariff
                                                          ?.platformType ===
                                                        "epex") && (
                                                          <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-2 ">
                                                            <span className="bold ">
                                                              {tariffDynamicConfiguration?.dynamicHourTariff?.platformType === "epex" ? "Select Region & Resolution :" : "Select Region :"}
                                                            </span>
                                                          </div>
                                                        )}
                                                      {tariffDynamicConfiguration
                                                        ?.dynamicHourTariff
                                                        ?.platformType === "omie" && (
                                                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ">
                                                            <div className="form-group row ">
                                                              <label
                                                                htmlFor="region"
                                                                className="col-sm-2 col-md-2 col-form-label text-right "
                                                              >
                                                                Countries
                                                              </label>

                                                              <div className="col-sm-3">
                                                                <select
                                                                  className="col-sm-12 col-lg-12 col-md-12 col-xl-12  form-control form-control-sm"
                                                                  name="country"
                                                                  id="platformDayAhead"
                                                                  value={
                                                                    tariffDynamicConfiguration
                                                                      ?.dynamicHourTariff
                                                                      ?.platformDayAhead
                                                                  }
                                                                  onChange={
                                                                    handleDynamicTariffConfiguration
                                                                  }
                                                                >
                                                                  <option
                                                                    value=" "
                                                                    disabled
                                                                    hidden
                                                                  >
                                                                    Select countries
                                                                  </option>
                                                                  {defaultDynamicTariff?.tariffTypeList?.[
                                                                    "24-Hour Day Ahead Tariff"
                                                                  ]?.[0]?.["OMIE"]?.map(
                                                                    (region) => (
                                                                      <option
                                                                        key={region}
                                                                        value={region}
                                                                      >
                                                                        {region}
                                                                      </option>
                                                                    )
                                                                  )}
                                                                </select>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}
                                                      {tariffDynamicConfiguration
                                                        ?.dynamicHourTariff
                                                        ?.platformType === "epex" && (
                                                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                            <div className="row">
                                                              <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2">
                                                                <div className="form-group row ">
                                                                  <label
                                                                    htmlFor="area"
                                                                    className="col-sm-3 col-md-3 col-form-label text-right "
                                                                  >
                                                                    Market Area
                                                                  </label>

                                                                  <div className="col-sm-5">
                                                                    <select
                                                                      className="col-sm-12 col-lg-12 col-md-12 col-xl-12  form-control form-control-sm"
                                                                      name="area"
                                                                      id="area"
                                                                      value={selectedEpexArea}
                                                                      onChange={
                                                                        handleDynamicTariffConfiguration
                                                                      }
                                                                    >
                                                                      <option
                                                                        value=" "
                                                                        disabled
                                                                        hidden
                                                                      >
                                                                        Select market area
                                                                      </option>
                                                                      {epexAreaList?.map((area) => (
                                                                        <option
                                                                          key={area}
                                                                          value={area}
                                                                        >
                                                                          {area}
                                                                        </option>
                                                                      ))}
                                                                    </select>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2">
                                                                <div className="form-group row ">
                                                                  <label
                                                                    htmlFor="resolution"
                                                                    className="col-sm-3 col-md-3 col-form-label text-right "
                                                                  >
                                                                    {"Resolution (Mins)"}
                                                                  </label>

                                                                  <div className="col-sm-5">
                                                                    <select
                                                                      className="col-sm-12 col-lg-12 col-md-12 col-xl-12  form-control form-control-sm"
                                                                      name="resolution"
                                                                      id="resolution"
                                                                      value={selectedEpexResolution}
                                                                      onChange={
                                                                        handleDynamicTariffConfiguration
                                                                      }
                                                                    >
                                                                      <option
                                                                        value=""
                                                                        disabled
                                                                        hidden
                                                                      >
                                                                        Select resolution
                                                                      </option>
                                                                      {epexResolutionList.map((resolution) => (
                                                                        <option
                                                                          key={resolution}
                                                                          value={resolution}
                                                                        >
                                                                          {resolution}
                                                                        </option>
                                                                      ))}
                                                                    </select>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      {tariffDynamicConfiguration?.tariffType ===
                                        "spotPrice" && (
                                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 mt-2">
                                            <div className="row pl-3">
                                              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <span className="bold">
                                                  Select Platform :{" "}
                                                </span>
                                              </div>
                                              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div className="row pl-3">
                                                  <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                                    <div className="custom-control custom-radio">
                                                      <input
                                                        type="radio"
                                                        id="AEMOBasedTariff"
                                                        name="platformSpotPrice"
                                                        className="custom-control-input islandableRadio  asCompatible"
                                                        checked={
                                                          tariffDynamicConfiguration
                                                            ?.spotPriceTariff
                                                            ?.platformSpotPrice ===
                                                          "aemo"
                                                        }
                                                        onClick={
                                                          handleDynamicTariffConfiguration
                                                        }
                                                        value="aemo"
                                                      />
                                                      <label
                                                        className="custom-control-label line-height-25px"
                                                        htmlFor="AEMOBasedTariff"
                                                      >
                                                        AEMO based tariff
                                                      </label>
                                                    </div>
                                                  </div>
                                                  {tariffDynamicConfiguration
                                                    ?.spotPriceTariff
                                                    ?.platformSpotPrice ===
                                                    "aemo" && (
                                                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1">
                                                        <div className="form-group row ">
                                                          <label
                                                            htmlFor="scale"
                                                            className="col-sm-2 col-md-2 col-form-label text-right "
                                                          >
                                                            Scale
                                                          </label>

                                                          <div className="col-sm-3">
                                                            <input
                                                              type="text"
                                                              autoComplete="none"
                                                              className="form-control form-control-sm"
                                                              name="scale"
                                                              placeholder="Enter Scale"
                                                              maxLength="50"
                                                              value={
                                                                tariffDynamicConfiguration
                                                                  ?.spotPriceTariff
                                                                  ?.scale
                                                              }
                                                              onChange={
                                                                handleDynamicTariffConfiguration
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                        <div className="form-group row ">
                                                          <label
                                                            htmlFor="region"
                                                            className="col-sm-2 col-md-2 col-form-label text-right "
                                                          >
                                                            Region
                                                          </label>

                                                          <div className="col-sm-3">
                                                            <select
                                                              className="col-sm-12 col-lg-12 col-md-12 col-xl-12  form-control form-control-sm"
                                                              name="region"
                                                              id="region"
                                                              value={
                                                                tariffDynamicConfiguration
                                                                  ?.spotPriceTariff
                                                                  ?.region
                                                              }
                                                              onChange={
                                                                handleDynamicTariffConfiguration
                                                              }
                                                            >
                                                              {defaultDynamicTariff.tariffTypeList?.[
                                                                "Spot Price"
                                                              ]?.[0]?.["AEMO"].map(
                                                                (region) => (
                                                                  <option
                                                                    key={region}
                                                                    value={region}
                                                                  >
                                                                    {region}
                                                                  </option>
                                                                )
                                                              )}
                                                            </select>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            {!["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(
                              projectKind?.projectTypeValue
                            ) && (
                                <div
                                  className="col-md-12 mt-2"
                                  label=" Sell Tariff Configuration"
                                  status={configuredStatus.sellTariffConfiguration}
                                  displayStatus="1"
                                  icon="notification_error_full_stroke"
                                  enableTemplatePopUp={enableTemplatePopUp}
                                >
                                  <div
                                    className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                                        projectStatusData?.projectStatus ===
                                        "COMPLETED" ||
                                        projectStatusData?.projectStatus ===
                                        "COMPLETED_AND_SEND"
                                        ? "se-block-disabled not-allowed"
                                        : !UserScope.access.saveProgram
                                          ? "se-block-disabled"
                                          : ""
                                      }`}
                                  >
                                    <div className="row">
                                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ">
                                        <div className="row pl-3 mt-1">
                                          <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                            <div className="custom-control custom-radio">
                                              <input
                                                type="radio"
                                                id="sellTariff1"
                                                name="sellTariff"
                                                className="custom-control-input islandableRadio  asCompatible"
                                                checked={sellTariff === "at0"}
                                                onClick={
                                                  handleDynamicTariffConfiguration
                                                }
                                                value="at0"
                                              />
                                              <label
                                                className="custom-control-label line-height-25px"
                                                htmlFor="sellTariff1"
                                              >
                                                Selling price equals zero
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                            <div className="custom-control custom-radio">
                                              <input
                                                type="radio"
                                                id="sellTariff2"
                                                name="sellTariff"
                                                className="custom-control-input islandableRadio  asCompatible"
                                                checked={sellTariff === "likeBuy"}
                                                onClick={
                                                  handleDynamicTariffConfiguration
                                                }
                                                value="likeBuy"
                                              />
                                              <label
                                                className="custom-control-label line-height-25px"
                                                htmlFor="sellTariff2"
                                              >
                                                Selling price equals purchase price
                                                minus delta
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        {sellTariff === "likeBuy" && (
                                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ">
                                            <div className="form-group row pl-3 mt-3">
                                              <label
                                                htmlFor="deltaSellTariff"
                                                className="col-sm-3 m-0"
                                              >
                                                {`Delta Sell Tariff ( ${currency?.symbol}/KWh )`}
                                                <se-tooltip position="right">
                                                  <se-icon
                                                    option="raised"
                                                    color="secondary"
                                                    slot="tooltip"
                                                  >
                                                    information_circle
                                                  </se-icon>
                                                  <se-tooltip-content>
                                                    {` Delta value > 0 for sell price lower than buy price`}
                                                  </se-tooltip-content>
                                                </se-tooltip>
                                              </label>

                                              <div className="col-sm-3">
                                                <input
                                                  type="text"
                                                  autoComplete="none"
                                                  className="form-control form-control-sm"
                                                  name="deltaSellTariff"
                                                  placeholder="Enter delta sell tariff"
                                                  maxLength="5"
                                                  value={deltaSellTariff}
                                                  onChange={
                                                    handleDynamicTariffConfiguration
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </Accordion>
                        </div>
                      </div>
                      {/* BESS Operating Modes */}
                      {(([
                        embLabels.GRID_CONNECTED_GSX,
                        embLabels.ISLANDABLE_GSX,
                        embLabels.GRID_CONNECTED,
                        embLabels.ISLANDABLE,
                      ].includes(siteType) &&
                        (gridSettings?.bessEnergyExchanges === true ||
                          gridSettings?.bessEnergyExchanges === false)) || (projectKind?.projectTypeValue === "NMGaaS ETO" && [
                            embLabels.OFF_GRID,
                            embLabels.GRID_CONNECTED,
                            embLabels.ISLANDABLE,
                          ].includes(siteType) && gridSettings?.bessOperatingModeType)) && (
                          <div
                            className="col-md-12"
                            label="BESS Operating Modes"
                            status={configuredStatus.bessOperatingModeStatus}
                            displayStatus={"1"}
                            icon="notification_error_full_stroke"
                          >
                            <div
                              className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-1 ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                                  projectStatusData?.projectStatus ===
                                  "COMPLETED" ||
                                  projectStatusData?.projectStatus ===
                                  "COMPLETED_AND_SEND"
                                  ? "se-block-disabled not-allowed"
                                  : !UserScope.access.saveProgram
                                    ? "se-block-disabled"
                                    : ""
                                } `}
                            >

                              {

                                (
                                  <div className="row">
                                    {((projectKind?.projectTypeValue === "NMGaaS ETO" && [
                                      embLabels.OFF_GRID,
                                      embLabels.GRID_CONNECTED,
                                      embLabels.ISLANDABLE,
                                    ].includes(siteType) &&  gridSettings?.bessOperatingModeType === "unrestricted") ||
                                      (projectKind?.projectTypeValue !== "NMGaaS ETO" && [
                                        embLabels.GRID_CONNECTED_GSX,
                                        embLabels.ISLANDABLE_GSX,
                                        embLabels.GRID_CONNECTED,
                                        embLabels.ISLANDABLE,
                                      ].includes(siteType) &&
                                        (gridSettings?.bessEnergyExchanges === true ||
                                          gridSettings?.bessEnergyExchanges === false)))
                                      &&
                                      <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                        <div className="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id="customRadioDegraded1"
                                            name="bessMode"
                                            className="custom-control-input islandableRadio  asCompatible"
                                            checked={
                                              isBessOperatingMode === "UNRESTRICTED"
                                            }
                                            onClick={exportManagementBessMode}
                                            value="UNRESTRICTED"
                                          />
                                          <label
                                            className="custom-control-label line-height-25px"
                                            htmlFor="customRadioDegraded1"
                                          >
                                            UNRESTRICTED
                                          </label>
                                          <se-tooltip
                                            action={
                                              isTouchDevice()
                                                ? "click"
                                                : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              "BESS can charge from grid and PV.
                                              BESS can discharge to grid"
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </div>
                                      </div>}
                                    {((
                                      (projectKind?.projectTypeValue === "NMGaaS ETO" && [
                                        embLabels.OFF_GRID,
                                        embLabels.GRID_CONNECTED,
                                        embLabels.ISLANDABLE,
                                      ].includes(siteType) &&  gridSettings?.bessOperatingModeType !== "unrestricted") ||
                                      (projectKind?.projectTypeValue !== "NMGaaS ETO" && [
                                        embLabels.GRID_CONNECTED_GSX,
                                        embLabels.ISLANDABLE_GSX,
                                        embLabels.GRID_CONNECTED,
                                        embLabels.ISLANDABLE,
                                      ].includes(siteType))) &&
                                      <>
                                        {
                                          <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                            <div className="custom-control custom-radio">
                                              <input
                                                type="radio"
                                                id="customRadioDegraded2"
                                                name="bessMode"
                                                className="custom-control-input islandableRadio  asCompatible"
                                                checked={
                                                  isBessOperatingMode ===
                                                  "EXPORT_ONLY"
                                                }
                                                onClick={exportManagementBessMode}
                                                value="EXPORT_ONLY"
                                              />
                                              <label
                                                className="custom-control-label line-height-25px"
                                                htmlFor="customRadioDegraded2"
                                              >
                                                EXPORT ONLY
                                              </label>
                                              <se-tooltip
                                                action={
                                                  (isTouchDevice()
                                                      ? "click"
                                                      : "hover")
                                                }
                                                position="right"
                                              >
                                                <se-icon
                                                  option="raised"
                                                  color="secondary"
                                                  slot="tooltip"
                                                >
                                                  information_circle
                                                </se-icon>
                                                <se-tooltip-content>
                                                  "BESS cannot charge from grid. It
                                                  can only charge from PV
                                                  production. BESS can discharge to
                                                  grid"
                                                </se-tooltip-content>
                                              </se-tooltip>
                                            </div>
                                          </div>}
                                        <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                          <div className="custom-control custom-radio">
                                            <input
                                              type="radio"
                                              id="customRadioDegraded3"
                                              className="custom-control-input islandableRadio  asCompatible"
                                              name="bessMode"
                                              checked={
                                                isBessOperatingMode ===
                                                "IMPORT_ONLY"
                                              }
                                              onClick={exportManagementBessMode}
                                              value="IMPORT_ONLY"
                                            />
                                            <label
                                              className="custom-control-label line-height-25px"
                                              htmlFor="customRadioDegraded3"
                                            >
                                              IMPORT ONLY
                                            </label>
                                            <se-tooltip
                                              action={
                                                (isTouchDevice()
                                                    ? "click"
                                                    : "hover")
                                              }
                                              position="right"
                                            >
                                              <se-icon
                                                option="raised"
                                                color="secondary"
                                                slot="tooltip"
                                              >
                                                information_circle
                                              </se-icon>
                                              <se-tooltip-content>
                                                "BESS can charge from grid and PV.
                                                BESS cannot discharge to grid"
                                              </se-tooltip-content>
                                            </se-tooltip>
                                          </div>
                                        </div>
                                        {<div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                          <div className="custom-control custom-radio">
                                            <input
                                              type="radio"
                                              id="customRadioDegraded4"
                                              name="bessMode"
                                              className="custom-control-input islandableRadio  asCompatible"
                                              checked={
                                                isBessOperatingMode ===
                                                "NO_EXCHANGE"
                                              }
                                              onClick={exportManagementBessMode}
                                              value="NO_EXCHANGE"
                                            />
                                            <label
                                              className="custom-control-label line-height-25px"
                                              htmlFor="customRadioDegraded4"
                                            >
                                              NO EXCHANGE
                                            </label>
                                            <se-tooltip
                                              action={
                                                (isTouchDevice()
                                                    ? "click"
                                                    : "hover")
                                              }
                                              position="right"
                                            >
                                              <se-icon
                                                option="raised"
                                                color="secondary"
                                                slot="tooltip"
                                              >
                                                information_circle
                                              </se-icon>
                                              <se-tooltip-content>
                                                "BESS cannot charge from grid. It
                                                can only charge from PV
                                                production. BESS cannot discharge
                                                to grid"
                                              </se-tooltip-content>
                                            </se-tooltip>
                                          </div>
                                        </div>}
                                      </>
                                    )}
                                  </div>
                                )}
                            </div>
                          </div>
                        )}
                     


                           {/* Limit Energy Import/Export (Based on EMA) */}
                    {["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(
                              projectKind?.projectTypeValue
                            ) && gridSettings?.exportOptimization === true && (
                      <div
                        className="col-md-12"
                        label="Limit Import/Export"
                        status={configuredStatus.emConfiguredStatus}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div
                          className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-1 ${
                            siteCreated ||
                            projectStatusData?.projectStatus === "COMPLETED" ||
                            projectStatusData?.projectStatus ===
                              "COMPLETED_AND_SEND"
                              ? "se-block-disabled not-allowed"
                              : !UserScope.access.saveProgram
                              ? "se-block-disabled"
                              : ""
                          }`}
                        >
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2">
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input asCompatible"
                                      name="limitEnergyImport"
                                      id="limitEnergyImport"
                                      value={limitImport}
                                      checked={limitImport}
                                      onChange={
                                        handleLimitExportImportOptimization
                                      }
                                    />
                                    <label
                                      className="custom-control-label line-height-25"
                                      htmlFor="limitEnergyImport"
                                    >
                                      Import Limitation
                                    </label>
                                    <se-tooltip
                                      action={
                                        true
                                          ? isTouchDevice()
                                            ? "click"
                                            : "hover"
                                          : ""
                                      }
                                      position="right"
                                    >
                                      <se-icon
                                        option="raised"
                                        color="secondary"
                                        slot="tooltip"
                                      >
                                        information_circle
                                      </se-icon>
                                      <se-tooltip-content>
                                        Limit energy importation from the grid,
                                        10 minutes time performance
                                      </se-tooltip-content>
                                    </se-tooltip>
                                  </div>
                                </div>
                              </div>

                              {limitImport === true && (
                                <div className="row pl-2">
                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                                    <div className="form-group row">
                                      <label
                                        htmlFor="inputEmail1112"
                                        className="col-sm-6 col-form-label"
                                      >
                                        Targeted Max Import Power (kW)
                                        <span className="se-mandatory">*</span>
                                        <span className="se-block-enabled">
                                          <se-tooltip
                                            action={
                                              isTouchDevice()
                                                ? "click"
                                                : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {getTooltipDataImportPower()?.[0]}
                                              <br></br>
                                              {getTooltipDataImportPower()?.[2]}
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </span>
                                      </label>
                                      <div className="col-sm-6">
                                        <input
                                          id="inputEmail112"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="maxLimitEnergyImportPower"
                                          placeholder="Targeted Max Import Power (kW)"
                                          maxLength="4"
                                          value={maxLimitEnergyImportPower}
                                          onChange={
                                            maxExportImportPowerChangeHandler
                                          }
                                        />
                                        {maxLimitEnergyImportPower?.toString() ===
                                          "" && (
                                          <div className="invalid-feedback-custom">
                                            Targeted Max Import Power (kW) is
                                            required.
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label
                                        htmlFor="peakStartImportHysteresis"
                                        className="col-sm-6 col-form-label"
                                      >
                                        Peak import start hysteresis
                                        {/* <span className="se-mandatory">*</span> */}
                                        <span className="se-block-enabled">
                                          <se-tooltip
                                            action={
                                              isTouchDevice()
                                                ? "click"
                                                : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {
                                                tooltipData
                                                  ?.peakImportStartHysteresis
                                                  ?.data
                                              }
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </span>
                                      </label>
                                      <div className="col-sm-3 input-group">
                                        <div className="input-group">
                                          <input
                                            id="peakStartImportHysteresis1"
                                            type="text"
                                            autoComplete="none"
                                            className="form-control form-control-md"
                                            name="peakImportHysteresisStartPercentage"
                                            maxLength="3"
                                            value={
                                              peakImportHysteresis?.startHysteresisPercent
                                            }
                                            onChange={
                                              maxExportImportPowerChangeHandler
                                            }
                                          />

                                          <div
                                            className="input-group-append"
                                            style={{ height: "38px" }}
                                          >
                                            <span
                                              className="input-group-text"
                                              style={{ padding: "5px" }}
                                            >
                                              %
                                            </span>
                                          </div>
                                        </div>
                                        {peakImportHysteresis?.startHysteresisPercent ===
                                          "" && (
                                          <div className="invalid-feedback-custom">
                                            {" "}
                                            Should be 0 - 100
                                          </div>
                                        )}
                                      </div>
                                      <div
                                        className="col-sm-3 input-group"
                                        style={{ paddingLeft: "0px" }}
                                      >
                                        <input
                                          id="peakStartImportHysteresis2"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="peakImportHysteresisStartKw"
                                          placeholder="kW"
                                          maxLength="4"
                                          value={
                                            peakImportHysteresis?.startHysteresisKw
                                          }
                                          // onChange={""}
                                          readonly
                                          disabled
                                        />
                                        <div
                                          className="input-group-append"
                                          style={{ height: "38px" }}
                                        >
                                          <span
                                            className="input-group-text"
                                            style={{ padding: "5px" }}
                                          >
                                            kW
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label
                                        htmlFor="peakImportHysteresisStop"
                                        className="col-sm-6 col-form-label"
                                      >
                                        Peak import stop hysteresis
                                        {/* <span className="se-mandatory">*</span> */}
                                        <span className="se-block-enabled">
                                          <se-tooltip
                                            action={
                                              isTouchDevice()
                                                ? "click"
                                                : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {
                                                tooltipData
                                                  ?.peakImportStopHysteresis
                                                  ?.data
                                              }
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </span>
                                      </label>
                                      <div className="col-sm-3 ">
                                        <div className="input-group">
                                          <input
                                            id="peakImportHysteresisStopPercentage"
                                            type="text"
                                            autoComplete="none"
                                            className="form-control form-control-md"
                                            name="peakImportHysteresisStopPercentage"
                                            maxLength="3"
                                            value={
                                              peakImportHysteresis?.stopHysteresisPercent
                                            }
                                            onChange={
                                              maxExportImportPowerChangeHandler
                                            }
                                          />
                                          <div
                                            className="input-group-append"
                                            style={{ height: "38px" }}
                                          >
                                            <span
                                              className="input-group-text"
                                              style={{ padding: "5px" }}
                                            >
                                              %
                                            </span>
                                          </div>
                                        </div>
                                        {peakImportHysteresis?.stopHysteresisPercent ===
                                          "" && (
                                          <div className="invalid-feedback-custom">
                                            {" "}
                                            Should be 0 - 100
                                          </div>
                                        )}
                                      </div>
                                      <div
                                        className="col-sm-3 input-group"
                                        style={{ paddingLeft: "0px" }}
                                      >
                                        <input
                                          id="peakImportHysteresisStop2"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="peakImportHysteresisStopKw"
                                          placeholder="kW"
                                          maxLength="4"
                                          value={
                                            peakImportHysteresis?.stopHysteresisKw
                                          }
                                          // onChange={""}
                                          readonly
                                          disabled
                                        />
                                        <div
                                          className="input-group-append"
                                          style={{ height: "38px" }}
                                        >
                                          <span
                                            className="input-group-text"
                                            style={{ padding: "5px" }}
                                          >
                                            kW
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            {
                              <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2">
                                <div className="row">
                                  <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input asCompatible"
                                        name="limitEnergyExport"
                                        id="limitEnergyExport"
                                        value={limitExport}
                                        checked={limitExport}
                                        onChange={
                                          handleLimitExportImportOptimization
                                        }
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="limitEnergyExport"
                                      >
                                        Export limitation
                                      </label>
                                      <se-tooltip
                                        action={
                                          true
                                            ? isTouchDevice()
                                              ? "click"
                                              : "hover"
                                            : ""
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          Limit energy export to the grid, 10
                                          minutes time performance
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>
                                </div>
                                {limitExport === true && (
                                  <div className="row pl-2">
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                      <div className="form-group row">
                                        <label
                                          htmlFor="inputEmail111"
                                          className="col-sm-6 col-form-label"
                                        >
                                          Targeted Max Export Power (kW)
                                          <span className="se-mandatory">
                                            *
                                          </span>
                                          <span className="se-block-enabled">
                                            <se-tooltip
                                              action={
                                                isTouchDevice()
                                                  ? "click"
                                                  : "hover"
                                              }
                                              position="right"
                                            >
                                              <se-icon
                                                option="raised"
                                                color="secondary"
                                                slot="tooltip"
                                              >
                                                information_circle
                                              </se-icon>
                                              <se-tooltip-content>
                                                {
                                                  tooltipData
                                                    ?.limitEnergyExportTooltipData
                                                    ?.data
                                                }
                                              </se-tooltip-content>
                                            </se-tooltip>
                                          </span>
                                        </label>
                                        <div className="col-sm-6">
                                          <input
                                            type="text"
                                            autoComplete="none"
                                            className="form-control form-control-md"
                                            name="maxLimitEnergyExportPower"
                                            placeholder="Targeted Max Export Power (kW)"
                                            maxLength="4"
                                            value={maxExportPower}
                                            onChange={
                                              maxExportImportPowerChangeHandler
                                            }
                                          />
                                          {maxLimitEnergyExportPower?.toString() ===
                                            "" && (
                                            <div className="invalid-feedback-custom">
                                              Targeted Max Export Power (kW) is
                                              required.
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    )}

                      {/* Limit Energy Import/Export (Based on EMA) */}
                      { !["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(
                              projectKind?.projectTypeValue
                            ) && (
                        <div
                          className="col-md-12"
                          label="Import Management"
                          status={configuredStatus.importManagementStatus}
                          displayStatus="1"
                          icon="notification_error_full_stroke"
                        >
                          <div
                            className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-1 ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                                projectStatusData?.projectStatus === "COMPLETED" ||
                                projectStatusData?.projectStatus ===
                                "COMPLETED_AND_SEND"
                                ? "se-block-disabled not-allowed"
                                : !UserScope.access.saveProgram
                                  ? "se-block-disabled"
                                  : ""
                              }`}
                          >
                            <div className="row">
                              <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2">
                                {(false)}
                                <div className="row">
                                  <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-2 ">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        id="limitedImport"
                                        className="custom-control-input islandableRadio  asCompatible"
                                        name="limitedImport"
                                        checked={limitImportExport?.importType === "Limited Import"}
                                        onClick={importManagementhandler}
                                        value="Limited Import"
                                      />
                                      <label
                                        className="custom-control-label line-height-25px"
                                        htmlFor="limitedImport"
                                      >
                                        Limited Import
                                      </label>
                                   {  (false)}
                                    </div>
                                  </div>
                                   <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-2 ">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        id="unrestrictedImport"
                                        className="custom-control-input islandableRadio  asCompatible"
                                        name="limitedImport"
                                        checked={limitImportExport?.importType === "Unrestricted Import"}
                                        onClick={importManagementhandler}
                                        value="Unrestricted Import"
                                      />
                                      <label
                                        className="custom-control-label line-height-25px"
                                        htmlFor="unrestrictedImport"
                                      >
                                        Unrestricted Import
                                      </label>
                                   {  (false)}
                                    </div>
                                  </div>
                                </div>


                                {(
                                  <div className="row pl-2">
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                                      <div className="form-group row">
                                        <label
                                          htmlFor="inputEmail1112"
                                          className="col-sm-6 col-form-label"
                                        >
                                         Maximum Import Power Limit
                                          <span className="se-mandatory">*</span>
                                          <span className="se-block-enabled">
                                            <se-tooltip
                                              action={
                                                isTouchDevice()
                                                  ? "click"
                                                  : "hover"
                                              }
                                              position="right"
                                            >
                                              <se-icon
                                                option="raised"
                                                color="secondary"
                                                slot="tooltip"
                                              >
                                                information_circle
                                              </se-icon>
                                              <se-tooltip-content>
                                                {getTooltipDataImportPower()?.[0]}
                                                <br></br>
                                                {getTooltipDataImportPower()?.[2]}
                                              </se-tooltip-content>
                                            </se-tooltip>
                                          </span>
                                        </label>
                                        <div className="col-sm-6">
                                          <div className="d-flex align-items-center">
                                            <input
                                              id="inputEmail112"
                                              type="text"
                                              autoComplete="none"
                                              className="form-control form-control-md"
                                              name="maxLimitEnergyImportPower"
                                              placeholder="Maximum Import Power Limit (kW)"
                                              maxLength="6"
                                              inputMode="numeric"
                                              value={limitImportExport?.maxLimitEnergyImportPower}
                                              onChange={ (e) => {
                                                if(!(limitImportExport?.importType === "Unrestricted Import"))
                                                  maxExportImportPowerChangeHandler(e);
                                                configuredStatusModified("importManagementStatus");
                                              }}
                                              disabled = {limitImportExport?.importType === "Unrestricted Import"}
                                            />
                                            <span className="ml-2">kW</span>
                                          </div>
                                          {limitImportExport?.maxLimitEnergyImportPower?.toString() ===
                                            "" && (
                                              <div className="invalid-feedback-custom">
                                                 Maximum Import Power Limit (kW) is
                                                required.
                                              </div>
                                            )}
                                            {Number(limitImportExport?.maxLimitEnergyImportPower?.toString()) > Number(derMaxPowerMap?.Utility) && (
                                              <div className="invalid-feedback-custom">
                                                {`Should be less than Utility (${derMaxPowerMap?.Utility})  breaker limit`}
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                   
                                      {false}
                                    </div>
                                  
                                  </div>
                                )}
                              </div>
                              
                            </div>
                          </div>
                        </div>
                      )}

                        {/* Export Optimization */}
                       {
                      //  gridSettings?.exportOptimization === true && 
                      !["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(
                              projectKind?.projectTypeValue
                            ) &&  (
                        <div
                          className="col-md-12"
                          label="Export Management"
                          status={configuredStatus.exportManagementStatus1}
                          displayStatus="1"
                          icon="notification_error_full_stroke"
                        >
                          <div
                            className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-1 ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                                projectStatusData?.projectStatus === "COMPLETED" ||
                                projectStatusData?.projectStatus ===
                                "COMPLETED_AND_SEND"
                                ? "se-block-disabled not-allowed"
                                : !UserScope.access.saveProgram
                                  ? "se-block-disabled"
                                  : ""
                              }`}
                          >
                            <div className="row">
                            
                              {
                                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2">
                                  <div className="row">
                                    {(false)}
                                       <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-2 ">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        id="noExport"
                                        className="custom-control-input islandableRadio  asCompatible"
                                        name="exportManagement"
                                        checked={limitImportExport?.exportType === "No Export"}
                                        onClick={ exportManagementhandler}
                                        value="No Export"
                                       
                                      />
                                      <label
                                        className="custom-control-label line-height-25px"
                                        htmlFor="noExport"
                                      >
                                        No Export
                                      </label>
                                   {  (false)}
                                    </div>
                                  </div>
                                  
                                   <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-2 ">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        id="unrestrictedExport"
                                        className="custom-control-input islandableRadio  asCompatible"
                                        name="exportManagement"
                                        checked={limitImportExport?.exportType === "Unrestricted Export"}
                                        onClick={exportManagementhandler}
                                        value="Unrestricted Export"
                                      />
                                      <label
                                        className="custom-control-label line-height-25px"
                                        htmlFor="unrestrictedExport"
                                      >
                                        Unrestricted Export
                                      </label>
                                   {  (false)}
                                    </div>
                                  </div>
                                   <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-2 ">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        id="limitedExport"
                                        className="custom-control-input islandableRadio  asCompatible"
                                        name="exportManagement"
                                        checked={limitImportExport?.exportType === "Custom Export" ||limitImportExport?.exportType === "Limited Export" }
                                        onClick={ exportManagementhandler}
                                        value="Custom Export"
                                         />
                                      <label
                                        className="custom-control-label line-height-25px"
                                        htmlFor="limitedExport"
                                      >
                                        Custom Export
                                      </label>
                                   {  (false)}
                                    </div>
                                  </div>
                                  </div>
                                  {(
                                    <> 
                                  {limitImportExport?.exportType !== "No Export" && <div className="row pl-2">
                                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <div className="form-group row">
                                          <label
                                            htmlFor="inputEmail111"
                                            className="col-sm-6 col-form-label"
                                          >
                                            Minimum PCC Power Limit
                                            <span className="se-mandatory">
                                              *
                                            </span>
                                            <span className="se-block-enabled">
                                              <se-tooltip
                                                action={
                                                  isTouchDevice()
                                                    ? "click"
                                                    : "hover"
                                                }
                                                position="right"
                                              >
                                                <se-icon
                                                  option="raised"
                                                  color="secondary"
                                                  slot="tooltip"
                                                >
                                                  information_circle
                                                </se-icon>
                                                <se-tooltip-content>
                                                  {
                                                    <>
                                                   { getLimitMaxEnergyExportTooltipData()?.[0]}
                                                    <br /><br />
                                                     { getLimitMaxEnergyExportTooltipData()?.[1]}
                                                    <br /><br />
                                                     { getLimitMaxEnergyExportTooltipData()?.[2]}
                                                    <br />
                                                    </>
                                                  }
                                                </se-tooltip-content>
                                              </se-tooltip>
                                            </span>
                                          </label>
                                          <div className="col-sm-6">
                                            <div className="d-flex align-items-center">
                                            <input
                                              type="text"
                                              autoComplete="none"
                                              className="form-control form-control-md"
                                              name="maxLimitEnergyExportPower"
                                              placeholder="Minimum PCC Power Limit (kW)"
                                              maxLength="6"
                                              value={limitImportExport?.maxLimitEnergyExportPower}
                                              onChange={ (e) => {
                                                if(!(limitImportExport?.exportType === "Unrestricted Export"))
                                                  maxExportImportPowerChangeHandler(e);
                                                configuredStatusModified("exportManagementStatus1");
                                              }}  
                                              disabled={limitImportExport?.exportType === "Unrestricted Export"}
                                            />
                                            <span className="ml-2">kW</span>
                                            </div>
                                            {limitImportExport?.maxLimitEnergyExportPower?.toString() ===
                                              "" && (
                                                <div className="invalid-feedback-custom">
                                                  Minimum PCC Power Limit (kW) is
                                                  required.
                                                </div>
                                              )}
                                                {limitImportExport?.maxLimitEnergyExportPower?.toString() !== "" &&
                                                  limitImportExport?.exportType === "Custom Export" &&
                                                  (Number(limitImportExport?.maxLimitEnergyExportPower?.toString()) < -Number(derMaxPowerMap?.Utility) ||
                                                    Number(limitImportExport?.maxLimitEnergyExportPower?.toString()) > Number(limitImportExport?.maxLimitEnergyImportPower?.toString())) && (
                                              <div className="invalid-feedback-custom">
                                               {`Should be greater than breaker limit(-${derMaxPowerMap?.Utility}) and less than or equal to Maximum Import Power Limit(${limitImportExport?.maxLimitEnergyImportPower})`}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>}
                                     {(projectKind?.projectTypeValue === "NMGaaS ETO" && limitImportExport?.exportType !== "No Export") && <> 
                                     
                                      <div className="row pl-2 pt-1 mb-2">
                                       
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-1">
                                          <div className="custom-control custom-checkbox">
                                            <input
                                              type="checkbox"
                                              className="custom-control-input asCompatible"
                                              name="pvExport"
                                              id="pvExport"
                                              value={limitImportExport?.pvExport}
                                              checked={limitImportExport?.pvExport}
                                              onChange={ (e) => {
                                                maxExportImportPowerChangeHandler(e);
                                                configuredStatusModified("exportManagementStatus1");
                                              }}  
                                            />
                                            <label
                                              className="custom-control-label line-height-25"
                                              htmlFor="pvExport"
                                            >
                                              PV Export
                                            </label>

                                          </div>
                                        </div>
                                      </div> </>}
                                    </>
                                  )}
                                </div>
                              }
                            </div>
                            { projectKind?.projectTypeValue === "NMGaaS ETO" &&
                               <div className="row">
                              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                                <span className="bold">
                                  Select export management functions
                                </span>
                              </div>
                            </div>
                            }
                            {projectKind?.projectTypeValue === "NMGaaS ETO" &&
                            clientType === embLabels.GREENSTRUXURE_PROJECT &&
                              siteType === embLabels.ISLANDABLE_GSX &&
                              architectureType === embLabels.PV_GENSET_ATS &&
                              gridSettings?.mode === "FUEL_SAVER" ? (
                              <>
                                <div className="row">
                                  <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input asCompatible"
                                        name="batteryBufferingExport"
                                        id="customControlValidation4"
                                        value={
                                          batteryDetails.batteryBufferingExport
                                        }
                                        checked={
                                          batteryDetails.batteryBufferingExport
                                        }
                                        disabled={
                                          siteType === embLabels.PV_HYBRIDIZATION
                                            ? true
                                            : batteryDetails.batteryBufferingStatus ===
                                              true &&
                                              (gridSettings?.noExport === true ||
                                                gridSettings?.exportOptimization ===
                                                true)
                                              ? false
                                              : true
                                        }
                                        style={
                                          siteType === embLabels.PV_HYBRIDIZATION
                                            ? //  ||
                                            //   (siteType === embLabels.ISLANDABLE_GSX &&
                                            //     architectureType === embLabels.PV_GENSET_ATS)
                                            { cursor: "not-allowed" }
                                            : { cursor: "pointer" }
                                        }
                                        onChange={
                                          (undefined)
                                        }
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="customControlValidation4"
                                      >
                                        Battery buffering
                                      </label>
                                      <span className="se-block-enabled">
                                        <se-tooltip
                                          action={
                                            [
                                              embLabels.ISLANDABLE,
                                              embLabels.GRID_CONNECTED,
                                            ].includes(siteType)
                                              ? isTouchDevice()
                                                ? "click"
                                                : "hover"
                                              : "hover"
                                          }
                                          position="right"
                                        >
                                          <se-icon
                                            option="raised"
                                            color="secondary"
                                            slot="tooltip"
                                            disabled={
                                              siteType ===
                                                embLabels.PV_HYBRIDIZATION
                                                ? //  ||
                                                //   (siteType === embLabels.ISLANDABLE_GSX &&
                                                //     architectureType ===
                                                //     embLabels.PV_GENSET_ATS)
                                                true
                                                : false
                                            }
                                          >
                                            information_circle
                                          </se-icon>
                                          <se-tooltip-content>
                                            {tooltipData?.batteryBuffering?.data}
                                          </se-tooltip-content>
                                        </se-tooltip>
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                {renderPvCurtailmentRow(
                                  "customControlValidation21",
                                  exportFunctionChangeHandler
                                )}

                                {renderUtilityLSIRow(
                                  "customControlValidationE3",
                                  tooltipData?.pVBreakersOpening?.data,
                                  !isExportFunctionEnabled
                                )}
                              </>
                            ) : (
                             projectKind?.projectTypeValue === "NMGaaS ETO" && <>
                               {  <div className="row">
                                  <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input asCompatible"
                                        name="batteryBufferingExport"
                                        id="customControlValidation4"
                                        checked={
                                          siteType ===
                                            embLabels.PV_HYBRIDIZATION ||
                                            (siteType ===
                                              embLabels.ISLANDABLE_GSX &&
                                              architectureType ===
                                              embLabels.PV_GENSET_ATS)
                                            ? false
                                            : batteryDetails.batteryBufferingExport
                                        }
                                        disabled={
                                          siteType === embLabels.PV_HYBRIDIZATION
                                            ? true
                                            : batteryDetails.batteryBufferingStatus ===
                                              true &&
                                              (gridSettings?.noExport === true ||
                                                gridSettings?.exportOptimization ===
                                                true)
                                              ? false
                                              : true
                                        }
                                        style={
                                          siteType ===
                                            embLabels.PV_HYBRIDIZATION ||
                                            (siteType ===
                                              embLabels.ISLANDABLE_GSX &&
                                              architectureType ===
                                              embLabels.PV_GENSET_ATS)
                                            ? { cursor: "not-allowed" }
                                            : { cursor: "pointer" }
                                        }
                                        onChange={
                                          (undefined)
                                        }
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="customControlValidation4"
                                      >
                                        Battery buffering
                                      </label>

                                      <span className="se-block-enabled">
                                        <se-tooltip
                                          action={
                                            [
                                              embLabels.ISLANDABLE,
                                              embLabels.GRID_CONNECTED,
                                            ].includes(siteType)
                                              ? isTouchDevice()
                                                ? "click"
                                                : "hover"
                                              : "hover"
                                          }
                                          position="right"
                                        >
                                          <se-icon
                                            option="raised"
                                            color="secondary"
                                            slot="tooltip"
                                            disabled={
                                              siteType ===
                                                embLabels.PV_HYBRIDIZATION ||
                                                (siteType ===
                                                  embLabels.ISLANDABLE_GSX &&
                                                  architectureType ===
                                                  embLabels.PV_GENSET_ATS)
                                                ? true
                                                : false
                                            }
                                          >
                                            information_circle
                                          </se-icon>
                                          <se-tooltip-content>
                                            {tooltipData?.batteryBuffering?.data}
                                          </se-tooltip-content>
                                        </se-tooltip>
                                      </span>
                                    </div>
                                  </div>
                                </div>}
                                {!(
                                  clientType ===
                                  embLabels.GREENSTRUXURE_PROJECT &&
                                  siteType === embLabels.GRID_CONNECTED_GSX &&
                                  architectureType === embLabels.PV_BESS_NR
                                ) && (
                                    <div className="row">
                                      <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                        <div className="custom-control custom-checkbox">
                                          <input
                                            type="checkbox"
                                            className="custom-control-input asCompatible"
                                            name="lossOfComm"
                                            id="isBessCBsMotorizedOrContactor"
                                            value={lossOfComm}
                                            checked={lossOfComm}
                                            disabled={
                                              gridSettings?.noExport === true ||
                                                gridSettings?.exportOptimization ===
                                                true
                                                ? isRealTimeExportConfg === true
                                                  ? true
                                                  : false
                                                : true
                                            }
                                            onChange={
                                              ["MGaaS IEC", "MGaaS ETO", "NMGaaS ETO"].includes(
                                                projectKind?.projectTypeValue
                                              ) && gridSettings?.spanishCodeRealTime
                                                ? undefined
                                                : exportFunctionChangeHandler
                                            }
                                          />
                                          <label
                                            className="custom-control-label line-height-25"
                                            htmlFor="isBessCBsMotorizedOrContactor"
                                          >
                                            Open BESS/PV breaker in case of loss of
                                            communication
                                          </label>
                                          <se-tooltip
                                            action={
                                              isTouchDevice() ? "click" : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {isMotorizedOrContactor?.isBessCBsMotorizedOrContactor ===
                                                false ? (
                                                "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches"
                                              ) : (
                                                <dl style={{ width: "285px" }}>
                                                  <dt>EMO-M will :</dt>
                                                  <dd>
                                                    - Open Battery breaker in case
                                                    of loss of communication with
                                                    Utility meter.
                                                  </dd>
                                                  <dd>
                                                    - Open PV breaker in case of
                                                    loss of communication with
                                                    Utility meter/PV inverter.
                                                  </dd>
                                                </dl>
                                              )}
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                {renderPvCurtailmentRow(
                                  "customControlValidation22",
                                  ["MGaaS IEC", "MGaaS ETO", "NMGaaS ETO"].includes(
                                    projectKind?.projectTypeValue
                                  ) && gridSettings?.spanishCodeRealTime
                                    ? undefined
                                    : exportFunctionChangeHandler
                                )}

                                {renderUtilityLSIRow(
                                  "isBessCBsMotorizedOrContactor",
                                  isMotorizedOrContactor?.isBessCBsMotorizedOrContactor ===
                                    false
                                    ? "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches"
                                    : tooltipData?.pVBreakersOpening?.data,
                                  gridSettings?.spanishCodeRealTime === true
                                    ? true
                                    : (gridSettings?.noExport === true ||
                                      gridSettings?.exportOptimization === true)
                                      ? (isRealTimeExportConfg === true
                                        ? true
                                        : false)
                                      : true
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      )}


                      {/* Load Shedding */}
                      {
                      // showLoadManagement && 
                      (
                        <div
                          className="col-md-12"
                          label="Load Management"
                          status={configuredStatus.lsConfiguredStatus}
                          displayStatus={"1"}
                          icon="notification_error_full_stroke"
                        >
                          <se-divider></se-divider>
                          <div className={loadManagementDisabledClass}> <LoadShedding /></div>
                        </div>
                      )}


                      {/* Real Time Export Control (EMO-M Based) */}
                      {gridSettings?.noExport === true ? (
                        <div
                          className="col-md-12"
                          label="Real Time Export Control (EMO-M Based)"
                          status={configuredStatus.exportManagementStatus}
                          displayStatus={projectTypeValue === "NMGaaS ETO" ? "0" : "1"}
                          icon="notification_error_full_stroke"
                        >
                          <div
                            className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-1 ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                                projectStatusData?.projectStatus === "COMPLETED" ||
                                projectStatusData?.projectStatus ===
                                "COMPLETED_AND_SEND"
                                ? "se-block-disabled not-allowed"
                                : !UserScope.access.saveProgram
                                  ? "se-block-disabled"
                                  : ""
                              }`}
                          >
                            <div className="dropdown-divider"></div>

                            {(false)
                            }

                            <div className="row">
                              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                                <span className="bold">
                                  Select export management functions
                                </span>
                              </div>
                            </div>

                         { projectKind?.projectTypeValue !== "NMGaaS ETO" &&
                         clientType === embLabels.GREENSTRUXURE_PROJECT &&
                          siteType === embLabels.ISLANDABLE_GSX &&
                          architectureType === embLabels.PV_GENSET_ATS &&
                          gridSettings?.mode === "FUEL_SAVER" ? (
                            <>
                              <div className="row">
                                <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input asCompatible"
                                      name="batteryBufferingExport"
                                      id="customControlValidation4"
                                      value={
                                        batteryDetails.batteryBufferingExport
                                      }
                                      checked={
                                        batteryDetails.batteryBufferingExport
                                      }
                                      disabled={
                                        siteType === embLabels.PV_HYBRIDIZATION
                                          ? true
                                          : batteryDetails.batteryBufferingStatus ===
                                              true &&
                                            (gridSettings?.noExport === true ||
                                              gridSettings?.exportOptimization ===
                                                true)
                                          ? false
                                          : true
                                      }
                                      style={
                                        siteType === embLabels.PV_HYBRIDIZATION
                                          ? //  ||
                                            //   (siteType === embLabels.ISLANDABLE_GSX &&
                                            //     architectureType === embLabels.PV_GENSET_ATS)
                                            { cursor: "not-allowed" }
                                          : { cursor: "pointer" }
                                      }
                                      onChange={
                                        (undefined)
                                      }
                                    />
                                    <label
                                      className="custom-control-label line-height-25"
                                      htmlFor="customControlValidation4"
                                    >
                                      Battery buffering
                                    </label>
                                    <span className="se-block-enabled">
                                      <se-tooltip
                                        action={
                                          [
                                            embLabels.ISLANDABLE,
                                            embLabels.GRID_CONNECTED,
                                          ].includes(siteType)
                                            ? isTouchDevice()
                                              ? "click"
                                              : "hover"
                                            : "hover"
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                          disabled={
                                            siteType ===
                                            embLabels.PV_HYBRIDIZATION
                                              ? //  ||
                                                //   (siteType === embLabels.ISLANDABLE_GSX &&
                                                //     architectureType ===
                                                //     embLabels.PV_GENSET_ATS)
                                                true
                                              : false
                                          }
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          {tooltipData?.batteryBuffering?.data}
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </span>
                                  </div>
                                </div>
                              </div>

                              {renderPvCurtailmentRow(
                                "customControlValidation21",
                                exportFunctionChangeHandler
                              )}

                              {renderUtilityLSIRow(
                                "customControlValidationE3",
                                tooltipData?.pVBreakersOpening?.data,
                                !isExportFunctionEnabled
                              )}
                            </>
                          ) : (
                            projectKind?.projectTypeValue !== "NMGaaS ETO" &&
                            <>
                              <div className="row">
                                <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input asCompatible"
                                      name="batteryBufferingExport"
                                      id="customControlValidation4"
                                      checked={
                                        siteType ===
                                          embLabels.PV_HYBRIDIZATION ||
                                        (siteType ===
                                          embLabels.ISLANDABLE_GSX &&
                                          architectureType ===
                                            embLabels.PV_GENSET_ATS)
                                          ? false
                                          : batteryDetails.batteryBufferingExport
                                      }
                                      disabled={
                                        siteType === embLabels.PV_HYBRIDIZATION
                                          ? true
                                          : batteryDetails.batteryBufferingStatus ===
                                              true &&
                                            (gridSettings?.noExport === true ||
                                              gridSettings?.exportOptimization ===
                                                true)
                                          ? false
                                          : true
                                      }
                                      style={
                                        siteType ===
                                          embLabels.PV_HYBRIDIZATION ||
                                        (siteType ===
                                          embLabels.ISLANDABLE_GSX &&
                                          architectureType ===
                                            embLabels.PV_GENSET_ATS)
                                          ? { cursor: "not-allowed" }
                                          : { cursor: "pointer" }
                                      }
                                      onChange={
                                        (undefined)
                                      }
                                    />
                                    <label
                                      className="custom-control-label line-height-25"
                                      htmlFor="customControlValidation4"
                                    >
                                      Battery buffering
                                    </label>

                                    <span className="se-block-enabled">
                                      <se-tooltip
                                        action={
                                          [
                                            embLabels.ISLANDABLE,
                                            embLabels.GRID_CONNECTED,
                                          ].includes(siteType)
                                            ? isTouchDevice()
                                              ? "click"
                                              : "hover"
                                            : "hover"
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                          disabled={
                                            siteType ===
                                              embLabels.PV_HYBRIDIZATION ||
                                            (siteType ===
                                              embLabels.ISLANDABLE_GSX &&
                                              architectureType ===
                                                embLabels.PV_GENSET_ATS)
                                              ? true
                                              : false
                                          }
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          {tooltipData?.batteryBuffering?.data}
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              {!(
                                clientType ===
                                  embLabels.GREENSTRUXURE_PROJECT &&
                                siteType === embLabels.GRID_CONNECTED_GSX &&
                                architectureType === embLabels.PV_BESS_NR
                              ) && (
                                <div className="row">
                                  <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input asCompatible"
                                        name="lossOfComm"
                                        id="isBessCBsMotorizedOrContactor"
                                        value={lossOfComm}
                                        checked={lossOfComm}
                                        disabled={
                                          gridSettings?.noExport === true ||
                                          gridSettings?.exportOptimization ===
                                            true
                                            ? isRealTimeExportConfg === true
                                              ? true
                                              : false
                                            : true
                                        }
                                        onChange={
                                          ["MGaaS IEC", "MGaaS ETO","NMGaaS ETO"].includes(
                                            projectKind?.projectTypeValue
                                          ) && gridSettings?.spanishCodeRealTime
                                            ? undefined
                                            : exportFunctionChangeHandler
                                        }
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="isBessCBsMotorizedOrContactor"
                                      >
                                        Open BESS/PV breaker in case of loss of
                                        communication
                                      </label>
                                      <se-tooltip
                                        action={
                                          isTouchDevice() ? "click" : "hover"
                                        }
                                        position="right"
                                      >
                                        <se-icon
                                          option="raised"
                                          color="secondary"
                                          slot="tooltip"
                                        >
                                          information_circle
                                        </se-icon>
                                        <se-tooltip-content>
                                          {isMotorizedOrContactor?.isBessCBsMotorizedOrContactor ===
                                          false ? (
                                            "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches"
                                          ) : (
                                            <dl style={{ width: "285px" }}>
                                              <dt>EMO-M will :</dt>
                                              <dd>
                                                - Open Battery breaker in case
                                                of loss of communication with
                                                Utility meter.
                                              </dd>
                                              <dd>
                                                - Open PV breaker in case of
                                                loss of communication with
                                                Utility meter/PV inverter.
                                              </dd>
                                            </dl>
                                          )}
                                        </se-tooltip-content>
                                      </se-tooltip>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {renderPvCurtailmentRow(
                                "customControlValidation22",
                                ["MGaaS IEC", "MGaaS ETO", "NMGaaS ETO"].includes(
                                  projectKind?.projectTypeValue
                                ) && gridSettings?.spanishCodeRealTime
                                  ? undefined
                                  : exportFunctionChangeHandler
                              )}

                              {renderUtilityLSIRow(
                                "isBessCBsMotorizedOrContactor",
                                isMotorizedOrContactor?.isBessCBsMotorizedOrContactor ===
                                  false
                                  ? "To be able to ensure circuit breaker operation, please update DER configuration by adding motor mechanism or circuit breaker to PV branches and/or BESS branches"
                                  : tooltipData?.pVBreakersOpening?.data,
                                gridSettings?.spanishCodeRealTime === true
                                  ? true
                                  : (gridSettings?.noExport === true ||
                                    gridSettings?.exportOptimization === true)
                                    ? (isRealTimeExportConfg === true
                                      ? true
                                      : false)
                                    : true
                              )}
                            </>
                          )}

                            {((clientType === embLabels.GREENSTRUXURE_PROJECT &&
                              siteType === embLabels.GRID_CONNECTED_GSX &&
                              architectureType === embLabels.PV_BESS_NR) ||
                              (clientType === embLabels.GREENSTRUXURE_PROJECT &&
                                siteType === embLabels.ISLANDABLE_GSX &&
                                architectureType ===
                                embLabels.PV_GENSET_ATS)) && (
                                <div className="row">
                                  <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 ">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input asCompatible"
                                        name="lossOfComm"
                                        id="customControlValidation23"
                                        value={lossOfComm}
                                        checked={lossOfComm}
                                        disabled={
                                          gridSettings?.noExport === true ||
                                            gridSettings?.exportOptimization === true
                                            ? false
                                            : true
                                        }
                                        onChange={exportFunctionChangeHandler}
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="customControlValidation23"
                                      >
                                        Degraded Mode
                                      </label>
                                      <Tooltip
                                        position="right"
                                        iconColor="secondary"
                                        information=" If EMA controller disconnected from EMO-M
                                  then charge the BESS to nominal state of
                                  charge. Export excess of PV Production to
                                  grid when BESS already charged to nominal."
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      ) : (
                        <div
                          className="col-md-12"
                          label="Real Time Export Control"
                          status="1"
                          displayStatus="0"
                          icon="notification_error_full_stroke"
                        ></div>
                      )}

                      {/* Real Time Import Control (EMA Controller Based) */}
                      {(false)}

                      {/* Manual Demand Response  */}
                      {gridSettings?.manualDemandResponse === true ? (
                        <div
                          className="col-md-12"
                          label="Manual Demand Response"
                          status={1}
                          displayStatus={projectTypeValue === "NMGaaS ETO" ? "0" : "1"}
                          icon="notification_error_full_stroke"
                        >
                          <div className="row pt-2 pl-4">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input asCompatible"
                                  name="manualDemandResponse"
                                  id="manualDemandResponse"
                                  value={gridSettings?.manualDemandResponse}
                                  checked={gridSettings?.manualDemandResponse}
                                  onChange={null}
                                />
                                <label
                                  className="custom-control-label line-height-25"
                                  htmlFor="manualDemandResponse"
                                >
                                  Enabled
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="col-md-12"
                          label="dummy Manual Demand Response"
                          status="1"
                          displayStatus="0"
                          icon="notification_error_full_stroke"
                        ></div>
                      )}

                      {/* Electrical Vehicle Energy Management  */}
                      {gridSettings?.electricalVehicleEnergyManagement ===
                        true ? (
                        <div
                          className="col-md-12"
                          label="Electrical Vehicle Energy Management"
                          status={1}
                          displayStatus="1"
                          icon="notification_error_full_stroke"
                        >
                          <div className="row pt-2 pl-4">
                            <div
                              className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-1 ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                                  projectStatusData?.projectStatus ===
                                  "COMPLETED" ||
                                  projectStatusData?.projectStatus ===
                                  "COMPLETED_AND_SEND"
                                  ? "se-block-disabled not-allowed"
                                  : !UserScope.access.saveProgram
                                    ? "se-block-disabled"
                                    : ""
                                }`}
                            >
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input asCompatible"
                                  name="electricalVehicleEnergyManagement"
                                  id="electricalVehicleEnergyManagement"
                                  value={
                                    eVceData?.isElectricalVehicleEnergyManagement || isTMHSelected
                                  }
                                  checked={
                                    eVceData?.isElectricalVehicleEnergyManagement || isTMHSelected
                                  }
                                  onChange={undefined}
                                />
                                <label
                                  className="custom-control-label line-height-25"
                                  htmlFor="electricalVehicleEnergyManagement"
                                >
                                  Enabled
                                </label>
                              </div>
                            </div>
                            {(gridSettings?.electricalVehicleEnergyManagement === true || isTMHSelected) &&
                              <>
                                {!isTMHSelected ?
                                  <div
                                    className={`col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2 ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                                        projectStatusData?.projectStatus ===
                                        "COMPLETED" ||
                                        projectStatusData?.projectStatus ===
                                        "COMPLETED_AND_SEND"
                                        ? "se-block-disabled not-allowed"
                                        : !UserScope.access.saveProgram
                                          ? "se-block-disabled"
                                          : ""
                                      }`}
                                  >
                                    <div className="form-group row">
                                      <label
                                        htmlFor="webServiceURL"
                                        className="col-sm-5 col-form-label"
                                      >
                                        Webservice URL
                                      </label>
                                      <div className="col-sm-6">
                                        <input
                                          id="webServiceURL"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="webServiceURL"
                                          placeholder="e.g. http://xxx.xxx.xx/"
                                          value={eVceData?.webServiceURL}
                                          onChange={handleEVCE}
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label
                                        htmlFor=" numberOfZones"
                                        className="col-sm-5 col-form-label"
                                      >
                                        Number of Zones
                                      </label>
                                      <div className="col-sm-6">
                                        <input
                                          id="numberOfZones"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="noOfZones"
                                          placeholder="e.g. 1,2,3,..."
                                          disabled
                                          value={eVceData?.noOfZones}
                                          onChange={(undefined)}
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label
                                        htmlFor=" componentId"
                                        className="col-sm-5 col-form-label"
                                      >
                                        Component ID
                                      </label>
                                      <div className="col-sm-6">
                                        <input
                                          id="componentId"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="componentIds"
                                          placeholder="e.g. EVCE1, EVCE2,..."
                                          disabled
                                          value={eVceData?.componentIds}
                                          onChange={(undefined)}
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label
                                        htmlFor="evMaxAllowedPower"
                                        className="col-sm-5 col-form-label"
                                      >
                                        EV Max Allowed Power (kW)
                                        <span className="se-block-enabled">
                                          <se-tooltip
                                            action={
                                              isTouchDevice() ? "click" : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {tooltipData?.evcemaxPower?.data}
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </span>
                                      </label>
                                      <div className="col-sm-6">
                                        <input
                                          id="evMaxAllowedPower"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="evMaxAllowedPower"
                                          placeholder="kW"
                                          disabled
                                          value={evMaxAllowedPower}
                                          onChange={(undefined)}
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label
                                        htmlFor="onPeakPowerLimit"
                                        className="col-sm-5 col-form-label"
                                      >
                                        High Tariff Power Limit (kW)
                                        <span className="se-block-enabled">
                                          <se-tooltip
                                            action={
                                              isTouchDevice() ? "click" : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {tooltipData?.powerLimit?.data}
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </span>
                                      </label>
                                      <div className="col-sm-6">
                                        <input
                                          id="onPeakPowerLimit"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="onPeakPowerLimit"
                                          placeholder="kW"
                                          value={eVceData?.onPeakPowerLimit}
                                          onChange={handleEVCE}
                                          disabled={evMaxAllowedPower === 0 ? true : false}
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label
                                        htmlFor="highTariffCurtailment"
                                        className="col-sm-5 col-form-label"
                                      >
                                        High Tariff Curtailment (%)
                                        <span className="se-block-enabled">
                                          <se-tooltip
                                            action={
                                              isTouchDevice() ? "click" : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {
                                                tooltipData?.highTariffCurtailment
                                                  ?.data
                                              }
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </span>
                                      </label>
                                      <div className="col-sm-6">
                                        <input
                                          id="highTariffCurtailment"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="highTariffCurtailment"
                                          placeholder="%"
                                          disabled
                                          value={eVceData?.highTariffCurtailment}
                                          onChange={handleEVCE}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  :
                                  <div
                                    className={`col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-2 ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                                        projectStatusData?.projectStatus ===
                                        "COMPLETED" ||
                                        projectStatusData?.projectStatus ===
                                        "COMPLETED_AND_SEND"
                                        ? "se-block-disabled not-allowed"
                                        : !UserScope.access.saveProgram
                                          ? "se-block-disabled"
                                          : ""
                                      }`}
                                  >
                                    {(false)}
                                    <div className="form-group row">
                                      <label
                                        htmlFor=" numberOfZones"
                                        className="col-sm-5 col-form-label"
                                      >
                                        Number of Zones
                                      </label>
                                      <div className="col-sm-6">
                                        <input
                                          id="numberOfZones"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="noOfZones"
                                          placeholder="e.g. 1,2,3,..."
                                          disabled
                                          value={eVceData?.noOfZones}
                                          onChange={(undefined)}
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <span className="col-sm-5 col-form-label bold">Max EV charging limit (kW)</span>
                                    </div>
                                    <div className="form-group row">
                                      <label
                                        htmlFor="evMaxAllowedPower"
                                        className="col-sm-5 col-form-label"
                                      >
                                        EV Max Allowed Power (kW) (Nominal case)
                                        <span className="se-block-enabled">
                                          <se-tooltip
                                            action={
                                              isTouchDevice() ? "click" : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {tooltipData?.evcemaxPower?.data}
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </span>
                                      </label>
                                      <div className="col-sm-6">
                                        <input
                                          id="evMaxAllowedPower"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="evMaxAllowedPower"
                                          placeholder="kW"
                                          disabled
                                          value={evMaxAllowedPower}
                                          onChange={(undefined)}
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label
                                        htmlFor="evMaxAllowedPowerDM"
                                        className="col-sm-5 col-form-label"
                                      >
                                        EV Max Allowed Power (kW) (Degraded Mode)
                                        <span className="se-block-enabled">
                                          <se-tooltip
                                            action={
                                              isTouchDevice() ? "click" : "hover"
                                            }
                                            position="right"
                                          >
                                            <se-icon
                                              option="raised"
                                              color="secondary"
                                              slot="tooltip"
                                            >
                                              information_circle
                                            </se-icon>
                                            <se-tooltip-content>
                                              {tooltipData?.evcemaxPower?.data}
                                            </se-tooltip-content>
                                          </se-tooltip>
                                        </span>
                                      </label>
                                      <div className="col-sm-6">
                                        <input
                                          id="evMaxAllowedPowerDM"
                                          type="text"
                                          autoComplete="none"
                                          className="form-control form-control-md"
                                          name="evMaxAllowedPowerDM"
                                          placeholder="kW"
                                          maxLength="6"
                                          value={eVceData?.evMaxAllowedPowerDM}
                                          onChange={handleEVCE}
                                        />
                                        <div
                                          className={`${eVceData?.evMaxAllowedPowerDM > evMaxAllowedPower
                                            ? "invalid-feedback-custom"
                                            : "hidden"
                                            }`}
                                        >
                                          {"EV Max Allowed Power (kW) (Degraded Mode) should be less than or equal to EV Max Allowed Power (kW) (Nominal case)"}
                                        </div>
                                      </div>

                                    </div>
                                  </div>

                                }
                              </>
                            }
                          </div>
                        </div>
                      ) : (
                        <div
                          className="col-md-12"
                          label="Electrical Vehicle Energy Management"
                          status="1"
                          displayStatus="0"
                          icon="notification_error_full_stroke"
                        ></div>
                      )}

                      {/* offGridMode Response  */}
                      {gridSettings?.offGridMode === true ? (
                        <div
                          className="col-md-12"
                          label="Off Grid Preparedness"
                          status={1}
                          displayStatus="1"
                          icon="notification_error_full_stroke"
                        >
                          <div className="row pt-2 pl-4">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input asCompatible"
                                  name="selfConsumption"
                                  id="customControlValidation3"
                                  value={gridSettings?.offGridMode}
                                  checked={gridSettings?.offGridMode}
                                  onChange={null}
                                />
                                <label
                                  className="custom-control-label line-height-25"
                                  htmlFor="customControlValidation3"
                                >
                                  Enabled
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="col-md-12"
                          label="dummy Off Grid Preparedness"
                          status="1"
                          displayStatus="0"
                          icon="notification_error_full_stroke"
                        ></div>
                      )}

                      {/* selfConsumption */}
                      {gridSettings?.selfConsumption === true &&
                        (projectTypeValue !== "DaaS ANSI" ||
                          projectTypeValue !== "DaaS ETO") ? (
                        <div
                          className="col-md-12"
                          label="Self Consumption"
                          status={1}
                          displayStatus={projectTypeValue === "NMGaaS ETO" ? "0" : "1"}
                          icon="notification_error_full_stroke"
                        >
                          <div className="row pt-2 pl-4">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input asCompatible"
                                  name="selfConsumption"
                                  id="customControlValidation3"
                                  value={gridSettings.selfConsumption}
                                  checked={gridSettings.selfConsumption}
                                  onChange={null}
                                />
                                <label
                                  className="custom-control-label line-height-25"
                                  htmlFor="customControlValidation3"
                                >
                                  Enabled
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="col-md-12"
                          label="dummy Self Consumption"
                          status="1"
                          displayStatus="0"
                          icon="notification_error_full_stroke"
                        ></div>
                      )}

                      {/* Outage mode preparation*/}
                      {gridSettings?.stormPreparedness === true ? (
                        <div
                          className="col-md-12"
                          label="Outage mode preparation"
                          status={1}
                          displayStatus="1"
                          icon="notification_error_full_stroke"
                        >
                          <div className="row pt-2 pl-4">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input asCompatible"
                                  name="Outage mode preparation"
                                  id="stormPreparedness1"
                                  value={gridSettings.stormPreparedness}
                                  checked={gridSettings.stormPreparedness}
                                  onChange={null}
                                />
                                <label
                                  className="custom-control-label line-height-25"
                                  htmlFor="stormPreparedness1"
                                >
                                  Enabled
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="col-md-12"
                          label="dummy Outage mode preparation"
                          status="1"
                          displayStatus="0"
                          icon="notification_error_full_stroke"
                        ></div>
                      )}

                      {/* Green Consumption */}
                      {gridSettings?.greenConsumption === true &&
                        projectTypeValue === "MGaaS ANSI" ? (
                        <div
                          className="col-md-12"
                          label="Green Consumption"
                          status={1}
                          displayStatus="1"
                          icon="notification_error_full_stroke"
                        >
                          <div className="row pt-2 pl-4">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input asCompatible"
                                  name="Green Consumption"
                                  id="greenConsumption1"
                                  value={gridSettings.greenConsumption}
                                  checked={gridSettings.greenConsumption}
                                  onChange={null}
                                />
                                <label
                                  className="custom-control-label line-height-25"
                                  htmlFor="greenConsumption1"
                                >
                                  Enabled
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="col-md-12"
                          label="dummy Green Consumption"
                          status="1"
                          displayStatus="0"
                          icon="notification_error_full_stroke"
                        ></div>
                      )}
                      {/* Net Metering */}
                      {(<div
                          className="col-md-12"
                          label="dummy Storm Preparation"
                          status="1"
                          displayStatus="0"
                          icon="notification_error_full_stroke"
                        ></div>)}
                      <div
                        className="col-md-12"
                        label="dummy on grid"
                        status={1}
                        displayStatus="0"
                        icon="notification_error_full_stroke"
                      ></div>
                      {gridSettings?.specificMonitoring === true &&
                        projectTypeValue === "MGaaS ANSI" ? (
                        <div
                          className="col-md-12"
                          label="Specific Monitoring"
                          status={1}
                          displayStatus="1"
                          icon="notification_error_full_stroke"
                        >
                          <div className="row pt-2 pl-4">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input asCompatible"
                                  name="Specific Monitoring"
                                  id="specificMonitoring"
                                  value={gridSettings.specificMonitoring}
                                  checked={gridSettings.specificMonitoring}
                                  onChange={null}
                                />
                                <label
                                  className="custom-control-label line-height-25"
                                  htmlFor="specificMonitoring"
                                >
                                  Enabled
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="col-md-12"
                          label="dummy Specific Monitoring"
                          status="1"
                          displayStatus="0"
                          icon="notification_error_full_stroke"
                        ></div>
                      )}
                      {gridSettings?.antiIslandingDetection === true &&
                        ["MGaaS IEC", "MGaaS ANSI", "MGaaS ETO", "NMGaaS ETO"].includes(
                          projectTypeValue
                        ) ? (
                        <div
                          className="col-md-12"
                          label="Anti Islanding Detection"
                          status={1}
                          displayStatus="1"
                          icon="notification_error_full_stroke"
                        >
                          <div className="row pt-2 pl-4">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 pl-4 se-block-disabled">
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input asCompatible"
                                  name="Anti Islanding Detection"
                                  id="antiIslanding"
                                  value={gridSettings.antiIslandingDetection}
                                  checked={gridSettings.antiIslandingDetection}
                                  onChange={null}
                                />
                                <label
                                  className="custom-control-label line-height-25"
                                  htmlFor="antiIslanding"
                                >
                                  Enabled
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="col-md-12"
                          label="dummy Anti Islanding"
                          status="1"
                          displayStatus="0"
                          icon="notification_error_full_stroke"
                        ></div>
                      )}
                    </Accordion>
                  </div>
                )}
              </div>
            </div>}
          </div>
        )}
      {/* Metering Priority */}
      {
        <div className={`row se-white-background pb-2`}>
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-2 ">
            <span className="se-font-14px-bold se-life-green ">
              Metering Priority
            </span>

            <div className="row ">
              {
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Accordion allowMultipleOpen>
                    <div
                      className="col-md-12"
                      label="dummy on grid"
                      status={1}
                      displayStatus="0"
                      icon="notification_error_full_stroke"
                    ></div>
                    {
                      <div
                        className="col-md-12"
                        label=" Metering Priority"
                        status={1}
                        displayStatus="1"
                        icon="notification_error_full_stroke"
                      >
                        <div
                          className={`row ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                              projectStatusData?.projectStatus === "COMPLETED" ||
                              projectStatusData?.projectStatus ===
                              "COMPLETED_AND_SEND"
                              ? "se-block-disabled"
                              : !UserScope.access.saveProgram
                                ? "se-block-disabled"
                                : ""
                            }`}
                        >
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 ">
                            <DevicePriority key={`device-priority-${outerResetTrigger}`} />
                          </div>
                        </div>
                      </div>
                    }
                  </Accordion>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <se-dialog
        id="AlertDialog"
        open={alertPopup.alertPopUpStatus}
        can-backdrop="false"
      >
        <se-dialog-header>{alertPopup.title}</se-dialog-header>
        <se-dialog-content
          icon="information_circle"
          color="primary"
          className="se-header-font-size-16px se-life-green"
        >
          {alertPopup.message}
        </se-dialog-content>
        <se-dialog-footer>
          <se-button onClick={closeAlertPopup}>OK</se-button>
        </se-dialog-footer>
      </se-dialog>
    </>
  );
};

export default OnGridOptimization;